
  import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
  import Home from './components/Home';
  import Contact from './components/contact';
  import Sign from './components/Signup';
  import Login from './components/Login';
  import Pass from './components/password';
  import Lan from './components/LandingPage';
  import Reso from './components/Reso';
  import T from './components/Text';
  import CustomToolbar from './components/CustomToolbar';
  import Road from './components/Roadmap';
  import Card from './components/ProfileCard';
  import Side from './components/Side';
  import LayoutWithDash from './components/Layout';
  import LayoutWithoutDash from './components/Layoutwithout';
  import  Dash  from './components/Dash';
  import Pro from './components/Project';
  import './App.css';
  import S from './components/Sources';
  import DevOpsResources from './components/DevOpsResources';
  import AdminResourceForm from './components/AdminResourceForm';
  import ProtectedRoute from './components/ProtectedRoute';

  function App() {
    return (
      <Router>
        <Routes>
          {/* Routes with Dash */}
          <Route element={<LayoutWithDash />}>
            <Route path="/" element={<Home />} />
            <Route path="/con" element={<Contact />} />
            {/* <Route path="/signup" element={<Sign />} />
            <Route path="/login" element={<Login />} />
            <Route path="/pass" element={<Pass />} /> */}
            <Route path="/lan" element={<Lan />} />
            <Route path="/Resoo" element={<Reso />} />
            {/* <Route path="/blog" element={<T />} /> */}
            <Route path="/ok" element={<CustomToolbar />} />
            <Route path="/road" element={<Road />} />
            <Route path="/ser" element={<Card />} />
            <Route path="/o" element={<Pro />} />
          </Route>

          <Route element={<LayoutWithoutDash />}>
            <Route path='/side' element={<Side />} />
            <Route path='/s' element={<S />} />
            <Route path="/signup" element={<Sign />} />
            <Route path="/login" element={<Login />} />
            <Route path="/pass" element={<Pass />} />
            <Route path="/blog" element={<T />} />
            <Route path="/resources" element={<DevOpsResources />} />
            <Route path="/admin/add-resource" element={<AdminResourceForm />} />
            <Route path="/admin/add-resource" element={
  <ProtectedRoute>
    <AdminResourceForm />
  </ProtectedRoute>
} />
           


          </Route>
        </Routes>
      </Router>
    );
  }

  export default App;
